// extracted by mini-css-extract-plugin
export var cartContainer = "_nv-4";
export var gray = "_nv-1";
export var itemContainer = "_nv-2";
export var itemDetails = "_nv-3";
export var strong = "_nv-0";